module.exports = {
    HIDDEN:             0,
    VISIBLE:            1,
    VISIBLE_GHOST:      2,
    INVISIBLE_GHOST:    3,      //
};